import { RefObject, useEffect } from 'react';

export function useSelect(
  ref: RefObject<HTMLElement>,
  callback: (e: MouseEvent) => void
) {
  useEffect(() => {
    const handleSelect = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as HTMLElement)) {
        callback(e);
      }
    };
    window.addEventListener('click', handleSelect);

    return () => {
      window.removeEventListener('click', handleSelect);
    };
  }, [ref, callback]);
}
